// extracted by mini-css-extract-plugin
export default {"cls1":"LanguageSwitcherModal-cls1___a7a59999b4b097800ef","cls2":"LanguageSwitcherModal-cls2___3381891c3d19f6080e0 LanguageSwitcherModal-cls1___a7a59999b4b097800ef"};